import { render, staticRenderFns } from "./ProductionAddDetail.vue?vue&type=template&id=70c02c1c&"
import script from "./ProductionAddDetail.vue?vue&type=script&lang=js&"
export * from "./ProductionAddDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductionAddDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports